<template>
  <div id="manager">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムトーーーク☆」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <SubHeader/>
    <p class="subTitle-row">コンパニオン編集</p>
    <div class="card-contents">
      <p style="text-align:left;">担当者ID：<br>
      <input v-model="id" type="text" name="id" placeholder="例）aaa@gmail.com"></p>
      <p style="text-align:left;">担当者パスワード：<br>
      <input v-model="password" type="text" name="password" placeholder="例）keipro0123"></p>
      <p style="text-align:left;">名前：<br>
      <input v-model="n" type="text" name="n" placeholder="例）ケイプロ ケイ子" id="name"></p>
       <p style="text-align:left;">年齢<span>(数字で記入してください)</span>：<br>
      <input v-model="age" type="text" name="age" placeholder="例）24" id="age"></p>
      <p style="text-align:left;">サムネイル画像①<span>(コンパニオンHPのメディアに保存した写真URLを記入してください)</span>：<br>
      <input v-model="thumbnail" type="text" name="thumbnail" id="thumbnail" placeholder="例）https://kei-corporation.jp/wp-content/uploads/2020/05/man.jpg"></p>
      <p style="text-align:left;">サムネイル画像②<span>(コンパニオンHPのメディアに保存した写真URLを記入してください)</span>：<br>
      <input v-model="thumbnail2" type="text" name="thumbnail2" id="thumbnail2" placeholder="例）https://kei-corporation.jp/wp-content/uploads/2020/05/man.jpg"></p>
      <p style="text-align:left;">サムネイル画像③<span>(コンパニオンHPのメディアに保存した写真URLを記入してください)</span>：<br>
      <input v-model="thumbnail3" type="text" name="thumbnail3" id="thumbnai3" placeholder="例）https://kei-corporation.jp/wp-content/uploads/2020/05/man.jpg"></p>
       <p style="text-align:left;">出身<span>(都道府県の文字を含めて記入してください)</span>：<br>
      <input v-model="from" type="text" id="from" name="from" placeholder="例）東京都"></p>
       <p style="text-align:left;">血液型<span>(型を抜きで記入してください)</span>：<br>
      <input v-model="blood" type="text" id="blood" name="blood" placeholder="例）A"></p>
       <p style="text-align:left;">星座<span>(座の文字を含めて記入してください)</span>：<br>
      <input v-model="sign" type="text" id="sign" name="sign" placeholder="例）水瓶座"></p>
       <p style="text-align:left;">趣味：<br>
      <input v-model="hobby" type="text" id="hobby" name="hobby" placeholder="例）ダンス"></p>
       <p style="text-align:left;">特技：<br>
      <input v-model="skill" type="text" id="skill" name="skill" placeholder="例）バク転"></p>
       <p style="text-align:left;">コメント：<br>
      <input v-model="comment" type="text" id="comment" name="comment" placeholder="例）楽しく話しましょう！！"></p>
      <p style="text-align:left;">初心者かどうか：</p>
      <select v-model="category" class="select" id="category">
      <option disabled value="">一つ選択してください。</option>
      <option value="○">○</option>
      <option value="✖︎">✖︎</option>
      </select>
      <p style="text-align:left;">公開するかどうか：</p>
      <select v-model="release" class="select" id="release">
      <option disabled value="">一つ選択してください。</option>
      <option value="○">○</option>
      <option value="✖︎">✖︎</option>
      </select>
      <button v-on:click="update()" id="send">更新</button>
    </div>
    <img v-on:click="showSerchBox()" src="../../assets/search.png" id="serch">
    <div id="modal" v-show="isModal">
      <p class="subTitle-row">コンパニオン選択</p>
      <p style="text-align:left;">名前を選択してください(完全一致)</p>
      <input v-model="serchCompanionName" type="text" name="serchCompanionName" placeholder="例）ケイプロ ケイ子">
      <button v-on:click="serch()" id="serchButton">検索</button>
      <img v-on:click="close()" src="../../assets/modal-close.png" id="close">
    </div>
    <Footer/>
  </div>
</template>
<style scoped>
#manager .subTitle-row{
  background-color:rgba(255,215,0,0.9);
  height: 50px;
  line-height: 50px;
  color: white;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 10px 10px 10px 10px;
  font-weight: bold;
  box-shadow: 4px 4px #555555;
}
span{
  font-size: 16px;
  font-style: italic;
}
.card-contents{
   box-shadow: 4px 4px #555555;
  background-color:rgba(208,255,67,0.7);
  border-radius: 10px 10px 10px 10px;
  width: 70%;
  margin:36px auto;
}
#manager .card-contents p{
  margin-right: 16px;
  margin-left: 16px;
   color: #555555;
  font-size: 20px;
}
#manager input{
  width: 90%;
  margin-left: 2%;
  border-radius: 10px 10px 10px 10px;
  height: 24px;
  font-size: 20px;
}
#send{
  border-radius: 20px 20px 20px 20px;
  background-color:rgba(255,215,0,0.9);
  color: white;
  border: 0px inset black;
  width: 200px;
  font-size: 20px;
  margin-top: 36px;
  margin-bottom: 36px;
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#serch{
  position: fixed;
  width: 80px;
  height: 80px;
  bottom: 5%;
  right: 5%;
}
#close{
display: block;
position: absolute;
width: 64px;
height:64px;
top:16px;
right:16px;
}
#manager select{
  display: block;
  width: 50%;
  height: 24px;
  margin-left: 4%;
}
#modal{
  width: 60%;
  height: 40%;
    background-color: white;
    z-index: 10000;
    top: 20%;
    position: absolute;
    left: 20%;
    box-shadow: 10px 10px 15px -10px;
    border-radius: 10px;
}
#modal input{
  width: 80%;
}
#modal p{
  width: 80%;
  margin-left: 10%;
  font-size: 24px;
}
#modal #close {
  position: absolute;
  width: 36px;
  height: 36px;
  top:8px;
  right: 8px;
}
#serchButton{
  display: block;
    margin-left: 30%;
    background-color:rgba(255,215,0,1.0);
    width: 40%;
    font-size: 20px;
    border-radius: 30px;
    margin-top: 8px;
    margin-bottom: 8px;
    color: white;
}
#serchButton:hover{
  background-color:orange;
}
@media ( max-width : 680px ){
  .card-contents{
  width: 90%;
}
  #sm-menu li{
    display: block;
   background-image: url(../../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  a {
  display: contents;
  text-decoration: none;
   color: white;
}
  #sm-menu ul{
    margin-top: 100px;
    padding : 0;
  }
  .subTitle-row{
    width: 90%;
  }
  #manager .item {
  border-radius: 10px;
   box-shadow: 4px 4px #555555;
  background-color:rgba(208,255,67,0.7);
  margin: 0 auto;
  width: 30%;
  text-align: center;
}
#manager .flexbox {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin-left: 5%;
    justify-content: center;
    }
    .main {
  margin-bottom: 10px;
  width: 100%;
}
span{
  font-size: 15px;
  font-style: italic;
}
.side {
  background-color:rgba(255,54,127,0.7);
  border-radius: 10px 10px 10px 10px;
  width: 100%;
  margin-bottom: 36px;
}
#manager .subTitle-row{
  width: 90%;
}
}
</style>
<script>
import SubHeader from '../common/SubHeader'
import Footer from '../common/Footer'
import firebase from 'firebase'

export default {
  name: 'app',
  components: {
    SubHeader, Footer
  },
  data () {
    return {
      db: null,
      id: '',
      password: '',
      n: '',
      age: '',
      thumbnail: '',
      thumbnail2: '',
      thumbnail3: '',
      from: '',
      blood: '',
      sign: '',
      hobby: '',
      skill: '',
      comment: '',
      category: '',
      release: '',
      isModal: false,
      serchCompanionName: '',
      changeId: '',
      thumbnailList: []
    }
  },
  created: function () {
    this.db = firebase.firestore()
  },
  methods: {
    update: function () {
      if (!this.id) {
        alert('担当者のIDが入力されていません。')
        return
      }
      if (!this.password) {
        alert('担当者のパスワードが入力されていません。')
        return
      }
      var exist = false
      var category = this.category
      var release = this.release
      var categoryBool = false
      var releaseBool = false
      var name = this.n
      var age = this.age
      var thumbnail = this.thumbnail
      var thumbnail2 = this.thumbnail2
      var thumbnail3 = this.thumbnail3
      var from = this.from
      var blood = this.blood
      var sign = this.sign
      var hobby = this.hobby
      var skill = this.skill
      var comment = this.comment
      var changeID = this.changeId
      var thumbnailList = this.thumbnailList
      var db = this.db
      db.collection('manager').where('id', '==', this.id).where('password', '==', this.password).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          exist = true
          if (!name) {
            alert('名前が入力されていません。')
            return
          }
          if (!age) {
            alert('年齢が入力されていません。')
            return
          }
          if (!thumbnail) {
            alert('一個目のサムネイル画像URLが入力されていません。')
            return
          }
          if (!thumbnail2) {
            alert('二個目のサムネイル画像URLが入力されていません。')
            return
          }
          if (!thumbnail3) {
            alert('三個目のサムネイル画像URLが入力されていません。')
            return
          }
          if (!category) {
            alert('初心者かどうかが入力されていません。')
            return
          }
          if (category === '○') {
            categoryBool = true
          }
          if (!release) {
            alert('公開するかどうかが入力されていません。')
            return
          }
          if (release === '○') {
            releaseBool = true
          }
          if (!changeID) {
            alert('再度変更するコンパニオンを選択してください。')
            return
          }
          thumbnailList.push(thumbnail)
          thumbnailList.push(thumbnail2)
          thumbnailList.push(thumbnail3)

          let collection = db.collection('companions').doc(changeID)
          return collection.update({
            name: name,
            age: parseInt(age, 10),
            thumbnail: thumbnail,
            from: from,
            blood: blood,
            sign: sign,
            hobby: hobby,
            skill: skill,
            comment: comment,
            isBiginer: categoryBool,
            isRelease: releaseBool,
            thumbnailList: thumbnailList
          })
            .then(function () {
              alert('コンパニオンの更新が完了しました。')
            })
            .catch(function (error) {
              console.log(error)
              alert('コンパニオンの更新に失敗しました。再度、実行してください。')
            })
        })
        if (!exist) {
          alert('入力されたIDとパスワードが異なります。マネージャーは存在しません。')
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('登録に失敗しました。エラーです。')
        })
    },
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    },
    showSerchBox: function () {
      this.isModal = true
    },
    serch: function () {
      if (!this.serchCompanionName) {
        alert('名前を入力してから、検索をしてください')
        return
      }
      let self = this
      this.db.collection('companions').where('name', '==', this.serchCompanionName).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          self.n = doc.data().name
          self.age = doc.data().age
          self.from = doc.data().from
          self.blood = doc.data().blood
          self.sign = doc.data().sign
          self.hobby = doc.data().hobby
          self.skill = doc.data().skill
          self.comment = doc.data().comment
          self.thumbnail = doc.data().thumbnail
          if (doc.data().thumbnailList) {
            self.thumbnail2 = doc.data().thumbnailList[1]
            self.thumbnail3 = doc.data().thumbnailList[2]
          }
          self.isModal = false
          self.changeId = doc.id
        })
      })
        .catch(function (error) {
          console.log(error)
          alert('登録に失敗しました。エラーです。')
        })
    },
    close: function () {
      this.isModal = false
    },
    show: function () {
      this.isModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manager/Update.vue